<template>
  <tr
      v-bind:class="{row_selected: is_selected}"
      v-on:click="onSelected"
      class="city-row-item"
  >
    <td style="color: #0171aa">{{name}}</td>
    <td>{{address}}</td>
    <td v-html="phone"></td>
    <td>{{email}}</td>
    <td><img src="@/assets/marker.png" alt="Google Maps"></td>
  </tr>
</template>

<script>

export default {
  name: 'CitiesTableItem',
  props: {
    id: Number,
    name: String,
    phone: String,
    address: String,
    email: String,
    city: String,
    lat: Number,
    lng: Number,
    is_selected: Boolean
  },
  methods: {
    onSelected: function() {
      this.emitter.emit('onSelected', {
        id: this.id
      });
    }
  }
}
</script>

<style lang="scss" scoped>
  .city-row-item {
    cursor: pointer;
    td {
      border-bottom: 1px dotted #adadad;
      vertical-align: middle;
      padding: 8px;
      font-family: sans-serif;
    }
  }
  .row_selected {
    background-color: rgb(239, 255, 229);
  }
</style>